<template>
  <div class="content">
    <div class="set_flexwrap">
      <div class="flex_wrap">
        <el-form ref="form" :rules="rules" :model="formdata" label-width="150px"  id="recruitCompany">
          <el-form-item label="显示线下提成比例">
            <el-radio-group v-model="formdata.commission_show" size="small">
              <el-radio-button
                      v-for="(item,index) in commissionshowtype"
                      :label="item.value"
                      :key="index"
              >{{item.label}}
              </el-radio-button>
            </el-radio-group>
            <p class="infodescribe">设置显示后，将会在app-商品列表（仅虚拟商品、线上展示商品）显示；可激励员工更积极的分享和跟进。</p>
          </el-form-item>
          <el-form-item label="显示内容" v-if="formdata.commission_show===0" prop="commission">
            预估可获得
            <el-input class="w80" v-model="formdata.commission" size="small"></el-input>
            %提成
          </el-form-item>
          <el-form-item class="mt-20">
            <el-button type="primary" @click="save('form')" size="small">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="preview_wrap">
        <div class="percentage_preview shopmallBody">
          <div class="title">示例图</div>
          <div class="percentage_wrap">
            <img src="/static/img/shopmallsettings.png" alt="" style="width: 100%;display: block;">
            <div class="content-body" v-show="formdata.commission_show!==1">
              <div class="content-list">
                <p>预估可获得{{formdata.commission}}%的佣金</p>
              </div>
              <div class="content-list">
                <p>预估可获得{{formdata.commission}}%的佣金</p>
              </div>
              <div class="content-list">
                <p>预估可获得{{formdata.commission}}%的佣金</p>
              </div>
              <div class="content-list">
                <p>预估可获得{{formdata.commission}}%的佣金</p>
              </div>
              <div class="content-list">
                <p>预估可获得{{formdata.commission}}%的佣金</p>
              </div>
              <div class="content-list">
                <p>预估可获得{{formdata.commission}}%的佣金</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import api from "@/api.js";
  import {commissionshowtype} from "@/util/util.js";

  export default {
    name: "offlineCommissionSetting",
    data() {
      return {
        commissionshowtype: commissionshowtype,
        formdata: {
          commission_show: "",
          commission: ""
        },
        rules: {
          commission: [{required: true, message: "请输入可获得提成", trigger: "blur"}]
        }
      };
    },
    created() {
      this.queryconfigcommission();
    },
    methods: {
      // 查询线下提成设置
      queryconfigcommission() {
        let params = {};
        this.axios
            .post(api.shopconf_commission, params)
            .then(response => {
              if (response.data.code == 0) {
                this.formdata.commission_show = response.data.info.commission_show;
                this.formdata.commission = parseInt(response.data.info.commission);
              } else {
              }
            })
            .catch(response => {
            });
      },
      // 保存
      save(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.submitsave();
          } else {
            return false;
          }
        });
      },

      // 保存
      submitsave() {
        let params = {
          commission_show: this.formdata.commission_show,
          commission:
              this.formdata.commission_show === 1 ? "" : this.formdata.commission
        };
        this.axios
            .post(api.shopconf_conf_edit, params)
            .then(response => {
              if (response.data.code == 0) {
                this.$message({
                  message: "保存成功",
                  type: "success"
                });
              } else {
              }
            })
            .catch(response => {
            });
      }
    }
  };
</script>
<style>
  .set_flexwrap {-webkit-box-shadow: none; box-shadow: none;}
  .shopmallBody{
    position: relative;
  }
  .content-body {
    position: absolute;
    top: 158px;
    left: 0;
    width: 100%;
    height: 654px;
  }
  .content-list{
    height: 109px;
    position: relative;
  }
  .content-list p{
    position: absolute;
    top: 60px;
    left: 108px;
    width: 200px;
    font-size: 12px;
    color: #666;
  }
</style>
